import React from "react";
import type { TreeNode } from "../../TreeView/types";

interface ContentViewProps {
    viewMode: "grid" | "list";
    items: TreeNode[];
    onNavigateToFolder: (node: TreeNode) => void;
    selectedItems: string[];
    onToggleItemSelection: (itemId: string) => void;
}

export const ContentView: React.FC<ContentViewProps> = ({ viewMode, items, onNavigateToFolder, selectedItems, onToggleItemSelection }) => {
    const renderItem = (item: TreeNode) => {
        const isSelected = selectedItems.includes(item.id);

        return (
            <div
                key={item.id}
                className={`
                    ${viewMode === "grid" ? "w-24 h-24" : "w-full h-12"} 
                    ${isSelected ? "bg-blue-100" : "hover:bg-gray-100"}
                    p-2 rounded-lg cursor-pointer flex flex-col items-center justify-center
                `}
                onClick={() => onToggleItemSelection(item.id)}
                onDoubleClick={() => onNavigateToFolder(item)}>
                <div className="flex items-center justify-center">{item.icon}</div>
                <div className="text-sm text-center mt-1 truncate w-full">{item.label}</div>
            </div>
        );
    };

    return (
        <div
            className={`
            ${viewMode === "grid" ? "grid grid-cols-[repeat(auto-fill,minmax(6rem,1fr))]" : "flex flex-col"} 
            gap-2 p-2
        `}>
            {items.map(renderItem)}
        </div>
    );
};
